import { useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "da", label: "Dansk", short: "DA" },
];

export default function LanguageSwitcher({ light = false }: { light?: boolean }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current =
    languages.find((l) => l.code === (i18n.language || "en")) || languages[0];

  const change = (code: string) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex h-9 items-center gap-1.5 rounded-full border px-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
          light
            ? "border-white/30 text-white hover:bg-white/10"
            : "border-background-200 bg-background-50 text-foreground-800 hover:bg-background-100"
        }`}
      >
        <i className="ri-global-line w-4 h-4 flex items-center justify-center" />
        <span>{current.short}</span>
        <i
          className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-sm">
            {languages.map((l) => (
              <button
                key={l.code}
                onClick={() => change(l.code)}
                className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm cursor-pointer transition-colors hover:bg-background-100 ${
                  l.code === current.code
                    ? "font-semibold text-primary-600"
                    : "text-foreground-700"
                }`}
              >
                {l.label}
                {l.code === current.code && (
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary-500" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}